import type { FaireProductEntity } from "../../entity_types/product";

export const p_hrgh7zfu4r: FaireProductEntity = {
  token: "p_hrgh7zfu4r",
  type: "product",
  name: "Mens Cross Charm Pendant Necklace in Stainless Steel",
  brandToken: "b_xd955m9fpf",
  brandName: "Perimade & Co. LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/4b640e714efff7f17e2e9161026cc9335e866fe3df91d6e453f0a88d0791f92e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cd3f5feda5f6bd3f3e4621da59408f11c9ef3e80cfc3d41f85962235b0c0b1d4.png",
    "https://cdn.faire.com/fastly/797b1a95664030d1d847c815263474920545f0865bd6650ffccf590e79b56e71.jpeg",
    "https://cdn.faire.com/fastly/c37680572023ac5b3bf0eb75dab5a460e5110af1f0d12564cd7868ebaa0ab3e7.png",
    "https://cdn.faire.com/fastly/8c89695c0a83881b78e738afc4636e38393dfd187ab920ea7c243b237b4d5b62.jpeg",
    "https://cdn.faire.com/fastly/0d3652c8a0954d7ebc36a9ab1e36832e4964eff540530ffec2ab07bcd092ace1.png",
    "https://cdn.faire.com/fastly/c102abc14a35fe3dd60d22247ba322c42fe7a902fba29a19a82495023723905b.jpeg",
  ],
  priceDollars: 9.66,
  description:
    "Description & Details\n\nAn iconic religious symbol, traditional yet modern, this pendant is a dazzling finishing touch for any look.\n\n * High quality titanium stainless steel \n * Hypoallergenic, gold plating \n * 20, 25, 30 mm cross pendant \n * 60 cm chain",
  tags: [],
  msrpDollars: 19.33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:24.726Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
